import { Flex } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import React from "react";
import {
  FormType,
  getLocationBoundariesFilterFormValue,
} from "src/scenes/orgAdmin/formTemplates/ContentTab/V1/formik";
import * as Draft from "src/scenes/orgAdmin/formTemplates/types/draft";
import { isLocationBoundariesFilter } from "src/services/formTemplateFilters";
import * as AF from "src/types/formTemplate";
import * as RD from "src/types/remoteData";
import { QuestionVisibility } from "../../QuestionVisibility";
import { ConfigureLocationBoundaries } from "../QuestionConfiguration/ConfigureLocationBoundaries";
import { ConfigureQuestion } from "../QuestionConfiguration/ConfigureQuestion";
import {
  ConfigureQuestionMenu,
  ConfigureQuestionMenuTabs,
} from "../QuestionConfiguration/ConfigureQuestionMenu";
import { SchoolItem } from "../types";
import { PermissionLevel } from "./PermissionLevel";
import { QuestionLink } from "./QuestionLink";

export type AddressQuestionFormProps = {
  verificationOptions: AF.FormVerification<AF.WithId>[];
  schools: RD.RemoteData<unknown, SchoolItem[]>;
  questionId: uuid;
  sectionType: AF.SectionType;
  otherQuestions: readonly Draft.Question[];
};
export function AddressQuestionForm({
  sectionType,
  verificationOptions,
  questionId,
  otherQuestions,
  schools,
}: AddressQuestionFormProps) {
  const [configureQuestionTab, setConfigureQuestionTab] =
    React.useState<ConfigureQuestionMenuTabs>(
      ConfigureQuestionMenuTabs.ConfigureQuestion
    );

  const formik = useFormikContext<FormType>();

  const handleConfigureMenuChange = (newTab: ConfigureQuestionMenuTabs) => {
    setConfigureQuestionTab(newTab);
  };

  const filters = getLocationBoundariesFilterFormValue(
    questionId,
    formik.values
  );

  const alreadyHasLocationBoundariesFilter = otherQuestions.some(
    (otherQuestion) =>
      (otherQuestion.filters?.filter(isLocationBoundariesFilter).length ?? 0) >
      0
  );

  return (
    <>
      <Flex direction="row" gap="4">
        <ConfigureQuestionMenu
          activeTab={configureQuestionTab}
          onMenuChange={handleConfigureMenuChange}
          items={[
            { type: "Separator", label: "Limit available options" },
            {
              type: ConfigureQuestionMenuTabs.LocationBoundaries,
              label: "Location Boundaries",
              status: filters.length > 0 ? "on" : "off",
            },
          ]}
        />
        {configureQuestionTab ===
          ConfigureQuestionMenuTabs.ConfigureQuestion && (
          <ConfigureQuestion
            questionId={questionId}
            questionType={AF.AddressType}
            verificationOptions={verificationOptions}
          />
        )}
        {configureQuestionTab ===
          ConfigureQuestionMenuTabs.LocationBoundaries && (
          <ConfigureLocationBoundaries
            questionId={questionId}
            disabled={alreadyHasLocationBoundariesFilter}
          />
        )}
      </Flex>
      {configureQuestionTab === ConfigureQuestionMenuTabs.ConfigureQuestion && (
        <Flex direction="column" flexGrow="1" gap="3">
          <QuestionLink questionId={questionId} />
          <PermissionLevel questionId={questionId} />
          <QuestionVisibility
            sectionType={sectionType}
            questionId={questionId}
            otherQuestions={otherQuestions}
            schools={schools}
          />
        </Flex>
      )}
    </>
  );
}
